export default "__VITE_ASSET__DFuHmWOj__"